var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "m15.328 6.136-8.936 8.936a1 1 0 0 0-.289.617l-.212 2.333a1 1 0 0 0 1.087 1.087l2.333-.212a1 1 0 0 0 .617-.29l8.936-8.935m-3.536-3.536 1.415-1.414a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.414l-1.414 1.415m-3.536-3.536 3.536 3.536"
  })));
};
export default SvgEdit;